/**
 *
 * Asynchronously loads the component for TaxpayerTaxReturns
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TaxpayerTaxreturnDetail = lazyLoad(
  () => import('./index'),
  (module) => module.TaxpayerTaxreturnDetail
);
